import { render, staticRenderFns } from "./DefaultSignupConfirmationAutLogin.vue?vue&type=template&id=49b3a88c&lang=pug&"
import script from "./DefaultSignupConfirmationAutLogin.vue?vue&type=script&lang=ts&"
export * from "./DefaultSignupConfirmationAutLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports